/* global tinymce:true */
/* global $:true */

/* eslint-disable */

tinymce.PluginManager.add('floatingtoolbar', function(editor)
{
	editor.on('init', function()
    {
        editor.settings.floatingtoolbar_top = editor.settings.floatingtoolbar_top || 0;
        editor.settings.floatingtoolbar_bottom = editor.settings.floatingtoolbar_bottom || 300;
        editor.settings.floatingtoolbar_selectors = editor.settings.floatingtoolbar_selectors || [window];

        var container = $(editor.editorContainer);
        var body = container.find('> .mce-container-body');
        var toolbar = $('<div class=\"mce-panel\"></div>').attr('id', editor.id + '_toolbar').prependTo(body);

        $('<div></div>').attr('id', editor.id + '_placeholder').prependTo(body);

        toolbar.append(container.find('.mce-menubar'));
        toolbar.append(container.find('.mce-toolbar-grp'));
    });

    editor.on('focus', function()
    {
        checkToolbars(editor, true);

        $.each(editor.settings.floatingtoolbar_selectors, function(i, selector)
        {
            $(selector).on('scroll.editor resize.editor', function()
            {
                checkToolbars(editor, true);
            });
        });
    });

    editor.on('blur', function()
    {
        $.each(editor.settings.floatingtoolbar_selectors, function(i, selector)
        {
            $(selector).off('scroll.editor resize.editor');
        });

        checkToolbars(editor, false);
    });

    function checkToolbars(editor, focus)
    {
        var minwidth = editor.settings.floatingtoolbar_minwidth || 0;
        var minheight = editor.settings.floatingtoolbar_minheight || 0;
        var top = $(window).width() > minwidth && $(window).height() > minheight ? editor.settings.floatingtoolbar_top : 0;
        var bottom = editor.settings.floatingtoolbar_bottom;

        var $editor = $(editor.editorContainer);
        var $toolbar = $('#' + editor.id + '_toolbar');
        var $placeholder = $('#' + editor.id + '_placeholder');

        if (focus == true)
        {
            var height = $editor.outerHeight();
            var scroll = $(window).scrollTop();
            var offset = $placeholder.offset();

            $placeholder.height($toolbar.outerHeight());
            $toolbar.outerWidth($placeholder.outerWidth());

            if (focus && offset && (offset.top - top) < scroll && (offset.top - top + height - bottom) > scroll)
            {
                $toolbar.css({
                    'position': 'fixed',
                    'border-bottom': '1px solid rgba(0, 0, 0, 0.2)',
                    'z-index': 1020,
                    'top': top + 'px'
                });

                return;
            }
        }

        $placeholder.height(0);
        $toolbar.css({
            'position': 'static',
            'border-bottom': 'none'
        });
    }
});
